import { render, staticRenderFns } from "./SimpleModal.vue?vue&type=template&id=1aeb5f32&scoped=true"
import script from "./SimpleModal.vue?vue&type=script&lang=js"
export * from "./SimpleModal.vue?vue&type=script&lang=js"
import style0 from "./SimpleModal.vue?vue&type=style&index=0&id=1aeb5f32&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aeb5f32",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1aeb5f32')) {
      api.createRecord('1aeb5f32', component.options)
    } else {
      api.reload('1aeb5f32', component.options)
    }
    module.hot.accept("./SimpleModal.vue?vue&type=template&id=1aeb5f32&scoped=true", function () {
      api.rerender('1aeb5f32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/SimpleModal.vue"
export default component.exports